import React from 'react';
import { Button } from '@drip/drip-design';
import { useConfig } from '@/apis/ducc';
import { data } from './data';
import Container from '@/components/container';
import './index.less';
import DetailHeaderInfoWrapper from '@/components/detail-header-info-wrapper';

export default function YXTools() {
  const [getConfig] = useConfig();
  const utilsList = JSON.parse(getConfig('TOOL_LIST', data)).filter((item) => !item.disabled);

  return (
    <div>
      <DetailHeaderInfoWrapper
        renderCrumbs={() => <div style={{ fontSize: 20, lineHeight: '28px' }}>营销工具</div>}
        background="url(//img30.360buyimg.com/pop/jfs/t1/189321/22/40862/62582/655db789Fc944a9b0/d2e6f2e3e90e0793.png) no-repeat right / contain, #D7E6F9"
        extraInfo={[{ value: '集成选品、制图、页面搭建、促销创建等多种常用功能，为用户营销活动提报提供便捷辅助工具' }]}
        backIcon={false}
        style={{ height: 120 }}
      />
      <Container>
        <div className="yxt-list">
          {utilsList.map((item) => {
            return (
              <div key={item.title} className="yxt-card-wrap">
                <div className="yxt-card">
                  <img src={item.icon} className="yxt-icon" />
                  <div className="yxt-title">{item.title}</div>
                  <div className="yxt-desc">{item.desc}</div>
                  <Button
                    type="primary"
                    onClick={() => {
                      window?.log('yx_center', 'marketingtool', '{"tool": "' + item.title + '"}');
                      window.open(item.link);
                    }}
                  >
                    立即创建
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
}
